query MediaItem($mediaItemId: ID!) {
    mediaItem(mediaItemId: $mediaItemId) {
        id
        name
        type
        folderId
        persistentKey
        info {
            tags {
                label
                type
                confidence
            }
        }
    }
}
